import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const track = (event, data = {}) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event, ...data });
};

export const getReviews = () => api.get("/content/reviews").then((r) => r.data);
export const getFaqs = (page) => api.get("/content/faqs", { params: page ? { page } : {} }).then((r) => r.data);
export const getResources = () => api.get("/content/resources").then((r) => r.data);
export const getResource = (slug) => api.get(`/content/resources/${slug}`).then((r) => r.data);
export const getGallery = () => api.get("/content/gallery").then((r) => r.data);

export const submitRollOff = (data) => api.post("/inquiries/roll-off", data).then((r) => r.data);
export const submitContractor = (data) => api.post("/inquiries/contractor", data).then((r) => r.data);
export const submitFrontLoad = (data) => api.post("/inquiries/front-load", data).then((r) => r.data);

export const adminLogin = (email, password) => api.post("/auth/login", { email, password }).then((r) => r.data);

export const adminApi = () => {
  const token = localStorage.getItem("yws_admin_token");
  return axios.create({ baseURL: API, headers: { Authorization: `Bearer ${token}` } });
};
